import { Theme, useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect } from "react";

/* Archivo para customizar los componentes que vienen de Amplify UI  */
export const amplifyCustomTheme: Theme = {
  name: "custom-amplify-theme",
  tokens: {
    fonts: {
      default: {
        variable: { value: "Montserrat" },
      },
    },
    colors: {
      brand: {
        primary: {
          10: { value: "#336B87" },
        },
      },
    },
    components: {
      fieldcontrol: {
        borderColor: { value: "#336B87" },
        borderRadius: { value: "20px" },
      },
      button: {
        primary: {
          backgroundColor: { value: "#336B87" },
          color: { value: "#FFFFFF" },
        },
      },
    },
  },
};
